import { Injectable } from '@angular/core';
import { CountryService } from '../other/country.service';
import { CountryModel } from '../../models/countries/country.model';
import { ECountryRegion } from '../../enums/countryRegion.enum';
import { RegionsModel } from '../../models/countries/regions.model';

@Injectable()
export class RegionsService {
  constructor(private _countryService: CountryService) {}

  /**
   * Retrieves a list of countries grouped by their respective regions.
   *
   * @returns {RegionsModel} An object containing arrays of countries grouped by region.
   * @remarks
   * This function iterates through the list of countries obtained from the `CountryService`
   * and categorizes them into different regions based on their `region` property.
   * The result is an object with properties for each region (africa, asia, australiaPacific,
   * europe, na, sa) and their corresponding arrays of countries.
   */
  public getRegionsList(): RegionsModel {
    const regions: RegionsModel = {
      africa: [],
      asia: [],
      australiaPacific: [],
      europe: [],
      na: [],
      sa: [],
    };

    this._countryService.getCountries().forEach((country: CountryModel) => {
      switch (country.region) {
        case ECountryRegion.AFRICA:
          regions.africa.push(country);
          break;
        case ECountryRegion.ASIA:
          regions.asia.push(country);
          break;
        case ECountryRegion.AUSTRALIA_PACIFIC:
          regions.australiaPacific.push(country);
          break;
        case ECountryRegion.EUROPE:
          regions.europe.push(country);
          break;
        case ECountryRegion.NORTH_AMERICA:
          regions.na.push(country);
          break;
        case ECountryRegion.SOUTH_AMERICA:
          regions.sa.push(country);
          break;
      }
    });

    return regions;
  }
}
